/**
 * @generated SignedSource<<27f8d9bd1ae2521ff5cc4a0843769828>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddIncludeAccountDispatchConditionInput = {
  accountIds: ReadonlyArray<string>;
  clientMutationId?: string | null;
  messageDispatchId: string;
};
export type useDispatchConditions_AddIncludeAccountDispatchConditionMutation$variables = {
  input: AddIncludeAccountDispatchConditionInput;
};
export type useDispatchConditions_AddIncludeAccountDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addIncludeAccountDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddIncludeAccountDispatchConditionMutation = {
  response: useDispatchConditions_AddIncludeAccountDispatchConditionMutation$data;
  variables: useDispatchConditions_AddIncludeAccountDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddIncludeAccountDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addIncludeAccountDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddIncludeAccountDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddIncludeAccountDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "928308cf436278cd3fe2a2517cd166d0",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddIncludeAccountDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddIncludeAccountDispatchConditionMutation(\n  $input: AddIncludeAccountDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addIncludeAccountDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a1c01e8f64dca37bed76c8d90760c0e";

export default node;
